<template>
  <div class="background">
    <slick-carousel
      v-if="bookingDetail.images"
      :images="bookingDetail.images"
      class="mb-4"
    ></slick-carousel>
    <div class="booking-status mb-3">
      <booking-status :value="2" class="booking-status mb-5"></booking-status>
      <div class="booking-row row">
        <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12">
          <div v-if="isAddressForm">
            <booking-fill-personal-detail
              v-model="customerDetail"
            ></booking-fill-personal-detail>
            <div class="submit-button-box">
              <div class="submit">
                <sc-button class="submit-button" @click="handlePrevious"
                  >ย้อนกลับ</sc-button
                >
                <sc-button
                  class="submit-button"
                  variant="primary"
                  @click="handleConfirmBooking"
                  >ยืนยันการส่งข้อมูล</sc-button
                >
              </div>
            </div>
          </div>
          <div v-else>
            <booking-description v-model="eventBooking"></booking-description>
          </div>
        </div>
        <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
          <booking-confirm-box
            :value="bookingDetail"
            :isAddressForm="isAddressForm"
            @handleBookingSubmit="handleBookingSubmit"
          ></booking-confirm-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConferenceImages from "../components/ConferenceImages";
import BookingStatus from "../components/BookingStatus.vue";
import BookingConfirmBox from "../components/BookingConfirmBox";
import BookingDescription from "../components/BookingDescription";
import {
  formatCurrencyBath,
  roundToTwoAndMultiplyOneHundred
} from "@/lib/formatter";
import BookingFillPersonalDetail from "../components/BookingFillPersonalDetail";
import ScButton from "@/lib/components/ScButton";
import {
  isValidEmail,
  isValidPhone,
  checkExistEveryValueInObject
} from "@/lib/util";
import { baanRueJaiClient } from "@/dependencies";
import { DateTime } from "luxon";
import { hyphenSymbol, textTime } from '../VariableStatic';
import slickCarousel from "@/lib/components/slickCarousel";

export default {
  components: {
    "conference-images": ConferenceImages,
    "booking-status": BookingStatus,
    "booking-confirm-box": BookingConfirmBox,
    "booking-description": BookingDescription,
    "booking-fill-personal-detail": BookingFillPersonalDetail,
    "sc-button": ScButton,
    "slick-carousel": slickCarousel
  },
  data() {
    return {
      eventBooking: {
        name: null,
        detail: null,
      },
      customerDetail: {
        firstName: null,
        lastName: null,
        addressForm: {
          zip_code: null,
          province_code: null,
          amphur_code: null,
          tumbon: null,
          address: null,
        },
        email: null,
        phoneNumber: null,
        companyName: null,
      },
      bookingDetail: null,
      isAddressForm: false,
    };
  },
  computed: {},
  watch: {},
  created() {
    if (!this.$route.params || !this.$route.params.paramBookings) {
      this.$router.push({
        name: "BookingCreate",
        params: { conferenceId: this.$route.params.conferenceId },
      });
    }

    this.setupBooking();

    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  methods: {
    async setupBooking() {
      const paramBookings = this.$route.params.paramBookings;

      const paramBookingsMapping = {
        roomTypeId: paramBookings.room_type_id,
        roomTitle: paramBookings.room_title,
        totalPrice: paramBookings.total_price,
        totalPriceText: formatCurrencyBath(paramBookings.total_price),
        bookingDateList: paramBookings.booking_date_list.map(
          (bookingDate, index) => {
            const breakOption = bookingDate.break_option
              ? {
                  packageId: bookingDate.break_option.package_id,
                  packageTitle: bookingDate.break_option.package_title,
                  breaks: bookingDate.break_option.break_time.map(
                    (breakTime, breakIndex) => {
                      return {
                        id: breakIndex + 1,
                        time: `${breakTime}${textTime}`,
                      };
                    }
                  ),
                  lunch: bookingDate.break_option.lunch,
                }
              : null;

            return {
              id: index + 1,
              date: bookingDate.date,
              timeDuration: bookingDate.time_duration,
              numberOfPeople: bookingDate.number_of_people,
              pattern: bookingDate.pattern,
              breakOption,
              price: bookingDate.price,
              priceText: formatCurrencyBath(bookingDate.price),
            };
          }
        ),
        images: paramBookings.images
      };

      this.bookingDetail = paramBookingsMapping;
    },
    handleBeforeUnload(event) {
      event.preventDefault();
      event.returnValue =
        "หากออกจากหน้านี้แล้ว ข้อมูลการจองทั้งหมดจะหายไป คุณต้องการจะออกหรือไม่?";
    },
    handleBookingSubmit() {
      if (
        !this.eventBooking ||
        !this.eventBooking.name
      ) {
        alert('กรุณากรอก "ชื่อ event"');
        return;
      }

      this.isAddressForm = true;
    },
    handlePrevious() {
      this.isAddressForm = false;
    },
    async handleConfirmBooking() {
      if (!this.checkValue()) {
        return;
      }

      const bookingDateList = this.bookingDetail.bookingDateList.map(
        (bookingDate) => {
          const bookingDateList = bookingDate.breakOption
            ? {
                package_id: bookingDate.breakOption.packageId,
                package_title: bookingDate.breakOption.packageTitle,
                break_times:
                  bookingDate.breakOption.breaks &&
                  bookingDate.breakOption.breaks.length > 0
                    ? bookingDate.breakOption.breaks.map((breakTime) =>
                        breakTime.time.replace(/ น./g, "")
                      )
                    : null,
                lunch_time: bookingDate.breakOption.lunch
                  && bookingDate.breakOption.lunch !== hyphenSymbol
                  ? bookingDate.breakOption.lunch.replace(/ น./g, "")
                  : null,
              }
            : null;

          return {
            date: DateTime.fromFormat(bookingDate.date, 'dd-MM-yyyy').toFormat("yyyy-MM-dd"),
            time_duration: bookingDate.timeDuration,
            number_of_people: +bookingDate.numberOfPeople,
            room_pattern: bookingDate.pattern,
            price: roundToTwoAndMultiplyOneHundred(bookingDate.price),
            break_option: bookingDateList, //สามารถ null ได้หากเลือกแค่ ห้องอย่างเดียว
          };
        }
      );

      const addressSelect = this.customerDetail.addressForm;
      const addressLocalSelect = this.customerDetail.addressForm.tumbon;

      if (!addressSelect || !addressLocalSelect) {
        alert("กรุณากรอก ที่อยู่");
        return;
      }

      const address = `${addressSelect.address} 
        ${addressLocalSelect.pre_tumbon}${addressLocalSelect.tumbon_name} ${addressLocalSelect.pre_amphur}${addressLocalSelect.amphur_name} 
        ${addressLocalSelect.province_name} ${addressLocalSelect.zip_code}`;

      const params = {
        room_type_id: +this.bookingDetail.roomTypeId,
        event_name: this.eventBooking.name,
        event_detail: this.eventBooking.detail || null,
        first_name: this.customerDetail.firstName,
        last_name: this.customerDetail.lastName,
        home_id: null,
        company_name: this.customerDetail.companyName,
        mobile: this.customerDetail.phoneNumber,
        email: this.customerDetail.email,
        total_price: roundToTwoAndMultiplyOneHundred(this.bookingDetail.totalPrice),
        comfirmed_at: null,
        status: null,
        booking_date_list: bookingDateList,
        address,
      };

      const bookingId = await this.postConferenceBooking(params);

      this.$router.push({
        name: "ConferenceBookingDetail",
        params: { bookingId: bookingId },
      });
    },
    async postConferenceBooking(params) {
      try {
        const { book_id } =  await baanRueJaiClient.others.conference.postMakeBooking(
          params
        );

        return book_id
      } catch (err) {
        console.error(err);

        alert("ไม่สามารถบันทึกการจองได้");
        return
      }
    },
    checkValue() {
      const checkingOptional = "+*-/-*/.";
      const customerDetailCheck = { ...this.customerDetail };

      // set optional params
      customerDetailCheck.companyName = `${checkingOptional}${this.customerDetail.companyName}`;

      const isEveryValueNotEmpty = checkExistEveryValueInObject(customerDetailCheck);

      const isEveryAddressValueNotEmpty = checkExistEveryValueInObject(
        customerDetailCheck.addressForm
      );

      if (!isEveryValueNotEmpty) {
        alert("กรุณากรอกข้อมูลให้ครบถ้วน");

        return false;
      } else if (!isEveryAddressValueNotEmpty) {
        alert('กรุณากรอกข้อมูล "ที่อยู่" ให้ครบถ้วน');

        return false;
      } else if (!isValidEmail(this.customerDetail.email)) {
        alert('กรุณากรอกข้อมูล "email" ให้ถูกต้อง');

        return false;
      } else {
        return true;
      }
    },
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";

.booking-row {
  min-height: 1000px;
}

.background {
  background-color: $white;
}

.booking-status {
  padding-left: 8%;
  padding-right: 8%;
  text-align: left;
}

.submit-button-box {
  text-align: center;
  padding-bottom: 15px;
}

@media screen and (max-width: $m-size) {
  .booking-status {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/other-web/Conference/pages/ConferenceBookingConfirm.vue